<h2 mat-dialog-title>
  {{ 'epd.functions.careplan-nnn.instruments-dialog.title' | translate | capitalize }}
</h2>
<mat-dialog-content class="instruments-dialog">
  <mat-form-field appearance="outline" class="instruments-dialog__search" [subscriptSizing]="'dynamic'">
    <input
      matInput
      type="text"
      [value]="searchText()"
      (input)="onSearchInput($event)"
      placeholder="{{ 'epd.functions.careplan-nnn.instruments-dialog.search-placeholder' | translate | capitalize }}" />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
  <div class="instruments-dialog__groups">
    @for (group of filteredGroups(); track group.id) {
      <section class="function-group">
        <h3 class="function-group__name">{{ group.name }}</h3>
        <ul class="function-group__list">
          @for (appFunction of group.functions; track appFunction.id) {
            <li class="function-group__item" [class.function-group__item--selected]="isChecked(appFunction.id)">
              <mat-checkbox [checked]="isChecked(appFunction.id)" (change)="toggle(appFunction.id)" color="primary">
                {{ appFunction.title }}
              </mat-checkbox>
            </li>
          }
        </ul>
      </section>
    } @empty {
      <p class="instruments-dialog__empty">
        {{ 'epd.functions.careplan-nnn.instruments-dialog.no-results' | translate | capitalize }}
      </p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>{{ 'general.words.cancel' | translate | capitalize }}</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="buildResult()">
    {{ 'general.actions.save' | translate | capitalize }}
  </button>
</mat-dialog-actions>
